import React from "react";
import {
  Alert,
  Card,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
} from "antd";
function CampaignModal({
  editing,
  saving,
  campuses,
  defaults,
  onSave,
  onCancel,
}) {
  const [form] = Form.useForm();
  const locked = editing?.id && editing.status !== "draft";
  return (
    <Modal
      title={editing?.id ? "Manage campaign" : "New campaign"}
      open={!!editing}
      onCancel={() => !saving && onCancel()}
      onOk={() => form.submit()}
      confirmLoading={saving}
      width={720}
      forceRender
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={editing}
        onFinish={onSave}
      >
        {locked && (
          <Alert
            message="Activated rules are immutable. Pause this campaign and create a new one to change future offers. Existing referral promises remain valid."
            type="info"
          />
        )}
        <Form.Item
          name="name"
          label="Campaign name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input disabled={locked} />
        </Form.Item>
        <Form.Item
          name="campus_id"
          label="Campus"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            disabled={locked}
            options={campuses.map((c) => ({
              value: c.id,
              label: c.name || c.campus_name || `Campus ${c.id}`,
            }))}
          />
        </Form.Item>
        <Space>
          <Form.Item
            name="starts_at"
            label="Starts"
            rules={[
              {
                required: !locked,
              },
            ]}
          >
            <Input type="datetime-local" disabled={locked} />
          </Form.Item>
          <Form.Item
            name="ends_at"
            label="Ends"
            rules={[
              {
                required: !locked,
              },
            ]}
          >
            <Input type="datetime-local" disabled={locked} />
          </Form.Item>
        </Space>
        <Form.Item
          name="budget"
          label="Maximum promotional allocation (INR)"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber min={1} max={1000000} disabled={locked} />
        </Form.Item>
        <Form.Item
          name="status"
          label="Status"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            options={(locked
              ? ["active", "paused", "ended"]
              : ["draft", "active"]
            ).map((x) => ({
              value: x,
              label: x,
            }))}
          />
        </Form.Item>
        <Card size="small" title="Earning rules">
          <Space wrap>
            {Object.keys(defaults || {}).map((key) => (
              <Form.Item
                key={key}
                name={["rules", key]}
                label={key.replaceAll("_", " ")}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={key === "max_credit_percent" ? 50 : 100000}
                  disabled={
                    locked ||
                    [
                      "redeem_points",
                      "credit_days",
                      "max_credit_percent",
                    ].includes(key)
                  }
                />
              </Form.Item>
            ))}
          </Space>
        </Card>
        <Form.Item
          name="reason"
          label="Reason for this change"
          rules={[
            {
              required: true,
              min: 5,
              max: 180,
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default CampaignModal;
